<div class="searchFormResultContainer">
  <his-search-form
    #SearchFormComponent
    [renderTitle]="renderTitle"
    [configFile]="searchConfigFile"
    [isSearchFormResult]="true"
    [isSearchPopup]="isSearchPopup"
    [presetInputFields]="presetInputFields"
    [hiddenSearchCriteriaPaths]="hiddenSearchCriteriaPaths"
    (searchSubmitted)="onSubmitSearch($event)"
    (formTitleLoaded)="onFormTitleLoaded($event)"
    [searchShowSearchParamsBox]="false"
    [hierarchyLevel]="hierarchyLevel">
    <p customSearchSet>
      <ng-content select="[passToForm]"></ng-content>
    </p>
  </his-search-form>
  <div class="clearerSpaceAboveHalfEm"></div>

  <!-- Suchergebnis erst zeigen wenn die Suche abgeschickt wurde -->
  <his-search-result
    #SearchResultComponent
    [searchConfigFile]="searchConfigFile"
    [genericSearchRowTooltipId]="genericSearchRowTooltipId"
    [isSearchFormResult]="true"
    [hisIcon]="hisIcon"
    [isSearchPopup]="isSearchPopup"
    [selectionSetting]="selectionSetting"
    [resultTableStyle]="resultTableStyle"
    [selectedOptions]="selectedOptions"
    [selectedOptionsIdColumn]="selectedOptionsIdColumn"
    [selectedOptionsLabelColumn]="selectedOptionsLabelColumn"
    [showNewSearchButton]="false"
    [showChangeSearchButton]="false"
    [showSearchInfo]="false"
    [resultRowsPerPage]="resultRowsPerPage"
    [customResultRowsTemplate]="customResultRowsTemplate"
    [class]="searchResultComponent.initialLoadFinished ? '' : 'hiddenQuicksearchElement'"
    (singleSelectionSubmited)="submitSingleSelection($event)"
    [showTableFilter]="showTableFilter"
    (filterToggled)="toggleTableFilter($event)"
    (finishedInitialLoad)="onFinishedInitialLoad()"
    [searchShowPrintviewButton]="searchShowPrintviewButton"
    [hierarchyLevel]="hierarchyLevel">

    @if (showTableFilter && toggleFilter) {
      <span>
        <ng-template #rowAction let-index="index" let-row="row">
          <!-- nothing else to show, only filter buttons -->
        </ng-template>
      </span>
    }

    @if (selectionSetting === selectionSettingEnum.MultiSelect) {
      <ng-container customResultButtons>
        <button type="submit" iconPos="left" class="marginRightStandard"
          (click)="submitSelection(); $event.preventDefault();">
          <span>{{'genericSearch.returnSelected' | hisUi}}</span>
        </button>
        <button type="submit" iconPos="left" 
          (click)="cancelSelection(); $event.preventDefault();">
          <span>{{'genericSearch.backToParentSearch' | hisUi}}</span>
        </button>
      </ng-container>
    }

    @if (selectionSetting === selectionSettingEnum.MultiSelect && renderCustomBottomResultButtons) {
      <ng-container customBottomResultButtons>
        <button iconPos="left" hisImage="TICK" class="marginRightStandard"
                (click)="submitSelection();">
          <span>{{'genericSearch.returnSelected' | hisUi}}</span>
        </button>
        <button iconPos="left" hisImage="RED_X" 
                (click)="cancelSelection();">
          <span>{{'genericSearch.backToParentSearch' | hisUi}}</span>
        </button>
      </ng-container>
    }
  </his-search-result>
</div>
